import { adicionarAnexo, LIMPAR_ANEXO, salvarAnexos } from "componentes/anexo/actions";
import { exibirMensagem, exibirErros } from "componentes/mensagem/actions";
import { iniciarEditor, limparEditor } from "componentes/editor/actions";
import { pegarConteudo } from "componentes/editor/seletores";
import { adicionarSituacoes as adicionarSituacoesParecer, adicionarParecer } from "paginas/parecer/actions";
import { adicionarSituacoes as adicionarSituacoesDecisao, adicionarDecisao } from "paginas/decisao/actions";

export const ADICIONAR_TIPOS_PROCESSO = "processo/ADICIONAR_TIPOS_PROCESSO";
export const ADICIONAR_TIPOS_REQUERENTE = "processo/ADICIONAR_TIPOS_REQUERENTE";
export const ADICIONAR_TIPOS_CONTA = "processo/ADICIONAR_TIPOS_CONTA";
export const ADICIONAR_INFRACAO = "processo/ADICIONAR_INFRACAO";
export const ATUALIZAR_PROCESSO = "processo/ATUALIZAR_PROCESSO";
export const ATUALIZAR_REQUERENTE = "processo/ATUALIZAR_REQUERENTE";
export const ADICIONAR_BANCOS = "processo/ADICIONAR_BANCOS";
export const DETALHAR_PROCESSO = "processo/DETALHAR_PROCESSO";
export const LIMPAR_PROCESSO = "processo/LIMPAR_PROCESSO";
export const ADICIONAR_RESPONSAVEIS = "processo/ADICIONAR_RESPONSAVEIS";
export const ADICIONAR_SITUACOES = "processo/ADICIONAR_SITUACOES";
export const ADICIONAR_ALEGACOES = "processo/ADICIONAR_ALEGACOES";

export const salvar = (evento, history) => (dispatch, getState) => {
  evento.preventDefault();
  // if (dadosInvalidos([...evento.target.elements])) {
  //   return dispatch(exibirMensagem({ msg: "Dados Inválidos.", tipo: "danger" }));
  // }
  const {
    anexo: { anexos },
    processo: {
      infracao,
      requerente,
      processo
    }
  } = getState();

  const alegacoes = pegarConteudo(getState(), "processo");
  const dados = {
    ...processo,
    alegacoes,
    infracao,
    requerente,
    anexos: anexos.map(anexo => {
      const { type, ...anexoResto } = anexo;
      return anexoResto;
    })
  }
  const modoAtualizacao = !!processo.id;
  const url = modoAtualizacao ? `/services/api/processos/${processo.id}` : "/services/api/processos/processos-legados";

  fetch(url, {
    method: modoAtualizacao ? "put" : "post",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(dados)
  })
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(processo => {
      dispatch(exibirMensagem({ msg: `Processo ${modoAtualizacao ? "atualizado" : "incluído"} com sucesso`, tipo: "success" }));
      dispatch(adicionarProcesso(processo));
      if (anexos.length > 0) {
        dispatch(salvarAnexos(processo.id, anexos))
          .then(arquivosJson => {
            let irParaAtualizacao = false;
            arquivosJson
              .forEach(anexo => {
                if (anexo.msg) {
                  dispatch(exibirMensagem({ msg: anexo.msg, tipo: "error" }));
                  irParaAtualizacao = true;
                }
                else {
                  dispatch(adicionarAnexo(anexo));
                  dispatch(exibirMensagem({ msg: `Anexo ${anexo.nome} cadastrado com sucesso!`, tipo: "success" }));
                }
              })
            history.push(`/processo/${processo.id}/${irParaAtualizacao ? "atualizar" : `tramitar/${processo.situacao.descricao}`}`);
          })
      }
      else {
        history.push(`/processo/${processo.id}/tramitar/${processo.situacao.descricao}`);
      }
    })
    .catch(erros => dispatch(exibirErros(erros)));
}

export const buscarDependenciasEspecificas = processo => dispatch => {
  const urlSituacoes = `/services/api/situacoes/${processo.id}/transicao-processo`;
  const urlAlegacoes = `/services/api/tipos-alegacao/${processo.fase.id}/fase`;
  const urlSituacoesParecer = `/services/api/situacoes-parecer/${processo.fase.id}/fase`;
  const urlSituacoesDecisao = `/services/api/situacoes-decisao/${processo.fase.id}/fase`;


  return Promise.all([
    fetch(urlSituacoes),
    fetch(urlSituacoesParecer),
    fetch(urlAlegacoes),
    fetch(urlSituacoesDecisao)
  ])
    .then(([
      rs,
      rsp,
      ra,
      rsd
    ]) => (
      rs.ok &&
      rsp.ok &&
      ra.ok &&
      rsd.ok)
        ? Promise.all([
          rs.json(),
          rsp.json(),
          ra.json(),
          rsd.json()
        ])
        : Promise.reject(["Erro ao recuperar os dados para a Tramitação", rs, rsp, ra, rsd]))
    .then(([
      situacoes,
      situacoesParecer,
      alegacoes,
      situacoesDecisao
    ]) => {
      dispatch({ type: ADICIONAR_SITUACOES, situacoes });
      dispatch(adicionarSituacoesParecer(situacoesParecer));
      dispatch({ type: ADICIONAR_ALEGACOES, alegacoes });
      dispatch(adicionarSituacoesDecisao(situacoesDecisao));
      return Promise.resolve(processo);
    })
    .catch(erros => Promise.reject(erros));
}

export const buscarDependencias = () => dispatch => {
  const urlTiposConta = "/services/api/tipos-conta";
  const urlBancos = "/services/api/bancos";
  const urlTiposProcesso = "/services/api/tipos-processo";
  const urlTiposRequerente = " /services/api/tipos-requerente";
  const urlResponsaveis = "/services/api/usuarios/cliente";

  return Promise.all([
    fetch(urlTiposConta),
    fetch(urlBancos),
    fetch(urlTiposProcesso),
    fetch(urlTiposRequerente),
    fetch(urlResponsaveis)
  ])
    .then(([
      rtc,
      rb,
      rtp,
      rtr,
      res
    ]) => (
      rtc.ok &&
      rb.ok &&
      rtp.ok &&
      rtr.ok &&
      res.ok)
        ? Promise.all([
          rtc.json(),
          rb.json(),
          rtp.json(),
          rtr.json(),
          res.json()
        ])
        : Promise.reject("Erro ao recuperar os dados para o processo"))
    .then(([
      tiposConta,
      bancos,
      tiposProcesso,
      tiposRequerente,
      responsaveis
    ]) => {
      dispatch({ type: ADICIONAR_BANCOS, bancos });
      dispatch({ type: ADICIONAR_TIPOS_PROCESSO, tiposProcesso });
      dispatch({ type: ADICIONAR_TIPOS_REQUERENTE, tiposRequerente });
      dispatch({ type: ADICIONAR_TIPOS_CONTA, tiposConta });
      dispatch({ type: ADICIONAR_RESPONSAVEIS, responsaveis });
      return Promise.resolve("Dependencias atualizadas");
    })
    .catch(erros => Promise.reject(erros));
}

export const buscarInfracao = (auto, codigo) => dispatch => {
  dispatch(limparProcesso());
  const urlInfracao = `/services/api/util/wsdenatram/infracao/${auto}/codigo/${codigo}`;

  dispatch(buscarDependencias())
    .then(depOK => fetch(urlInfracao))
    .then(ri => ri.ok ? ri.json() : Promise.reject(ri))
    .then(infracao => {
      dispatch({ type: ADICIONAR_INFRACAO, infracao });
    })
    .catch(erros => dispatch(exibirErros(erros)));
}

export const quandoMudar = ({ target: { name, value: valor } }) => dispatch => {
  const [prefixo, campo] = name.split("_");
  if (prefixo === "requerente") return dispatch(quandoMudarRequerente(campo, valor));
  if (prefixo === "processo") return dispatch(quandoMudarProcesso(campo, valor));
}

const quandoMudarRequerente = (campo, valor) => (dispatch, getState) => {
  const { requerente, infracao } = getState().processo;
  switch (campo) {
    case "cep": {
      const CEP_TAMANHO = 8;
      const cep = valor.replace(/[^0-9]+/g, "");
      if (cep.length >= CEP_TAMANHO) {
        return dispatch(buscarEndereco(cep));
      }
      let endereco = requerente.endereco || {};
      endereco = { ...endereco, cep };
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { endereco } });
      break;
    }
    case "telefone": {
      const telefone = valor.replace(/[^0-9]+/g, "");
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { telefone } });
      break;
    }
    case "numero":
    case "complemento": {
      let endereco = requerente.endereco || {};
      endereco = { ...endereco, [campo]: valor };
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { endereco } });
      break;
    }
    case "cpfOuCnpj": {
      const cpfOuCnpj = valor.replace(/[_.\-/]/g, "");
      const cpf = cpfOuCnpj.length < 12 ? cpfOuCnpj : "";
      const cnpj = cpfOuCnpj.length > 11 ? cpfOuCnpj : "";
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { cpf, cnpj } });
      break;
    }
    case "idTipoRequerente": {
      const TIPO_PROPRIETARIO = "1";
      const TIPO_CONDUTOR = "2";
      const TIPO_PROCURADOR = "3";
      if (valor === TIPO_PROPRIETARIO) {
        const { proprietario: { nome = "", cpf = "", cnpj = "", identidade = "", cnh = "" } = {} } = infracao.veiculo;
        dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { identidade, nome, cpf, cnpj, cnh } });
      }

      if (valor === TIPO_CONDUTOR) {
        const { nome = "", cpf = "", cnpj = "", identidade = "", cnh = "" } = infracao.condutor;
        dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { nome, cpf, cnpj, cnh, identidade } });
      }

      if (valor === TIPO_PROCURADOR) {
        dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { nome: "", cpf: "", cnpj: "", cnh: "", identidade: "" } });
      }
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { tipoRequerente: { id: parseInt(valor, 10) } } });
      break;
    }
    case "tipoConta":
    case "idBanco": {
      let dadosBancarios = requerente.dadosBancarios || {};
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { dadosBancarios: { ...dadosBancarios, [campo]: parseInt(valor, 10) } } });
      break;
    }
    case "agencia":
    case "conta": {
      let dadosBancarios = requerente.dadosBancarios || {};
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { dadosBancarios: { ...dadosBancarios, [campo]: valor } } });
      break;
    }
    default:
      dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { [campo]: valor } });
      break;
  }
}

const quandoMudarProcesso = (campo, valor) => (dispatch, getState) => {
  switch (campo) {

    case "tiposAlegacao":
      {
        const { alegacoes } = getState().processo;
        const tiposAlegacao = alegacoes.filter(alegacao => valor.includes(alegacao.id));
        dispatch({ type: ATUALIZAR_PROCESSO, processo: { [campo]: tiposAlegacao } });
        break;
      }
    case "cpfResponsavel": {
      dispatch({ type: ATUALIZAR_PROCESSO, processo: { responsavel: { cpf: valor } } });
      break;
    }
    case "idSituacao": {
      dispatch({ type: ATUALIZAR_PROCESSO, processo: { situacao: { id: parseInt(valor, 10) } } });
      break;
    }
    default:
      dispatch({ type: ATUALIZAR_PROCESSO, processo: { [campo]: valor } });
      break;
  }
}


// const dadosInvalidos = elementos => {
//   elementos
//     .filter(input => input.name)
//     .map(({ name, value }) => console.log(`${name}: ${value}`))
//   return true;
// }

const buscarEndereco = cep => dispatch => {
  fetch(`/services/api/util/dne/${cep}`)
    .then(rc => rc.ok ? rc.json() : Promise.reject(rc))
    .then(endereco => dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { endereco: { ...endereco, "numero": "", "complemento": "" }, erroCep: false } }))
    .catch(erros => dispatch({ type: ATUALIZAR_REQUERENTE, requerente: { erroCep: true, endereco: { cep } } }));
}

export const buscarProcesso = (processoId) => dispatch => {
  dispatch(limparProcesso());
  const urlProcesso = `/services/api/processos/${processoId}`;
  fetch(urlProcesso)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(processo => dispatch(adicionarProcesso(processo)))
    .catch(erros => dispatch(exibirErros(erros)));
}

export const limparProcesso = () => dispatch => {
  dispatch({ type: LIMPAR_ANEXO });
  dispatch({ type: LIMPAR_PROCESSO });
  dispatch(limparEditor("processo"));
}

export const adicionarProcesso = processoJson => dispatch => {
  dispatch(limparProcesso());

  const { infracao, requerente, anexos, parecer, decisao, ...processo } = processoJson;
  dispatch({ type: ADICIONAR_INFRACAO, infracao });
  dispatch({ type: ATUALIZAR_REQUERENTE, requerente });
  dispatch({ type: ATUALIZAR_PROCESSO, processo });
  dispatch(iniciarEditor("processo", processo.alegacoes));
  if (anexos.length > 0) {
    anexos.forEach(anexo => {
      dispatch(adicionarAnexo(anexo));
    });
  }
  if (parecer) {
    dispatch(adicionarParecer(parecer));
  }
  if (decisao) {
    dispatch(adicionarDecisao(decisao));
  }
  if (!processo.situacao.fim) {
    dispatch(buscarDependencias(processo.id))
      .then(depOK => dispatch(buscarDependenciasEspecificas(processo)))
      .catch(erros => Promise.reject(erros));
  }
}

export const enviarComentario = evento => (dispatch, getState) => {
  evento.preventDefault();
  const { processo: { id } } = getState().processo;
  const urlComentario = `/services/api/processos/${id}/comentarios`;
  const dados = {
    texto: pegarConteudo(getState())
  };
  fetch(urlComentario, {
    method: "put",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(dados)
  })
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(comentarios => {
      dispatch(exibirMensagem({ msg: "Comentário enviado com sucesso", tipo: "success" }));
      dispatch({ type: ATUALIZAR_PROCESSO, processo: { comentarios } });
      dispatch(limparEditor());
    })
    .catch(erros => dispatch(exibirErros(erros)));
}



// WEBPACK FOOTER //
// ./src/paginas/processo/actions.js